<script>
import Swal from "sweetalert2";
import "@fullcalendar/core/vdom";
import { SimpleBar } from "simplebar-vue3";
import { CalendarIcon } from "@zhuowenli/vue-feather-icons";

import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";

import FullCalendar from "@fullcalendar/vue3";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

// import { INITIAL_EVENTS } from "./calendar";
import axios from "axios";
import moment from "moment/moment";
import jwt_decode from "jwt-decode";

export default {
  props: {
    mode: {
      type: String,
      default: 'agent'
    },
    departmentId: {
      type: [String, Number],
      default: null
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    event: {
      title: {
        required: helpers.withMessage("Title is required", required),
      },
      category: {
        required: helpers.withMessage("Category is required", required),
      },
    },
  },
  watch: {
    mode(newMode) {
      if (newMode === 'license-class') {
        const teacher = this.isTeacher();
        this.calendarOptions.editable = teacher;
        this.calendarOptions.selectable = teacher;
        this.calendarOptions.droppable = teacher;
      } else if (newMode === 'leader-interviews' || newMode === 'combined') {
        this.calendarOptions.editable = false;
        this.calendarOptions.selectable = false;
        this.calendarOptions.droppable = false;
      } else {
        this.calendarOptions.editable = true;
        this.calendarOptions.selectable = true;
        this.calendarOptions.droppable = true;
      }
      this.refetchEvents();
    },
    departmentId() {
      this.refetchEvents();
    }
  },
  page: {
    title: "Calendar",
  },
  data() {
    return {
      title: "Calendar",
      items: [
        {
          text: "Apps",
          href: "/",
        },
        {
          text: "Calendar",
          active: true,
        },
      ],
      categories: [
        {
          name: 'Danger',
          value: 'bg-danger'
        },
        {
          name: 'Success',
          value: 'bg-success'
        },
        {
          name: 'Primary',
          value: 'bg-primary'
        },
        {
          name: 'Info',
          value: 'bg-info'
        },
        {
          name: 'Dark',
          value: 'bg-dark'
        },
        {
          name: 'Warning',
          value: 'bg-warning'
        },
      ],
      currentEvents: [],
      showModal: false,
      eventModal: false,
      submitted: false,
      submit: false,
      newEventData: {},
      edit: {},
      deleteId: {},
      event: {
        id: "",
        title: "",
        description: "",
        category: "",
        start: null,
        end: null,
        location: "",
      },
      editevent: {
        editID: 0,
        editTitle: "",
        editcategory: "",
        editDescription: "",
        editStart: "",
        editEnd: "",
        editLocation: "",
      },
      interviewModal: false,
      selectedInterview: {
        title: "",
        start: "",
        location: "",
        email: "",
        phoneNumber: "",
        interviewLink: "",
        departmentName: ""
      },
      description: "",
      dateTimeConfig: {
        enableTime: true,
        dateFormat: "F j, Y H:i K"
      },
      toDate:  null,
      fromDate: null,
      calendarOptions: {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        droppable: true,
        navLinks: true,
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        themeSystem: "bootstrap",
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
        },
        windowResize: () => {
          this.getInitialView();
        },
        initialView: this.getInitialView(),
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        dateClick: this.dateClicked,
        eventClick: this.editEvent,
        eventsSet: this.handleEvents,
        eventDrop: async (info) => {
          const editTitle = info.event.title;
          const localID = info.event.extendedProps?.localID || info.event.id;
          const googleEventID = info.event.extendedProps?.googleEventID || info.event.id;
          const providerID = info.event.extendedProps?.providerID || 'google';

          const url = this.mode === 'license-class' ? '/api/saveLicenseClassEvent' : '/api/updateEvent';
          const payload = this.mode === 'license-class' ? {
            token: localStorage.getItem('jwt'),
            action: 'update',
            event: {
              id: localID,
              title: editTitle,
              start: info.event.start?.toISOString(),
              end: info.event.end ? info.event.end.toISOString() : null,
              description: info.event.extendedProps?.description || '',
              location: info.event.extendedProps?.location || '',
              className: 'license-class'
            }
          } : {
            token: localStorage.getItem('jwt'),
            userEmail: localStorage.getItem('email'),
            userID: localStorage.getItem('id'),
            event: {
              editID: localID,
              googleEventID: googleEventID,
              providerID: providerID,
              editTitle: editTitle,
              editcategory: info.event.classNames?.[0] || '',
              editDescription: info.event.extendedProps?.description || '',
              editStart: info.event.start?.toISOString(),
              editEnd: info.event.end ? info.event.end.toISOString() : null,
              editLocation: info.event.extendedProps?.location || '',
            },
          };

          await axios.post(url, payload);
        },
        eventResize: async (event) => {
          this.submit = true;
          const editTitle = event.event.title;
          const editcategory = event.event.classNames[0];

          this.edit = event.event;
          this.edit.setProp("title", editTitle);
          this.edit.setProp("classNames", editcategory);

          const localID = event.event.extendedProps?.localID || event.event.id;
          const googleEventID = event.event.extendedProps?.googleEventID || event.event.id;
          const providerID = event.event.extendedProps?.providerID || 'google';

          const url = this.mode === 'license-class' ? '/api/saveLicenseClassEvent' : '/api/updateEvent';
          const payload = this.mode === 'license-class' ? {
            token: localStorage.getItem('jwt'),
            action: 'update',
            event: {
              id: localID,
              title: editTitle,
              start: event.event.start?.toISOString(),
              end: event.event.end ? event.event.end.toISOString() : null,
              description: event.event.extendedProps?.description || '',
              location: event.event.extendedProps?.location || '',
              className: 'license-class'
            }
          } : {
            token: localStorage.getItem('jwt'),
            userEmail: localStorage.getItem('email'),
            userID: localStorage.getItem('id'),
            event: {
              editID: localID,
              googleEventID: googleEventID,
              providerID: providerID,
              editTitle: editTitle,
              editcategory: editcategory,
              editDescription: event.event.extendedProps?.description || '',
              editStart: event.event.start ? new Date(event.event.start).toISOString() : null,
              editEnd: event.event.end ? new Date(event.event.end).toISOString() : null,
              editLocation: event.event.extendedProps?.location || ''
            },
            edit: this.edit
          };

          await axios.post(url, payload)
              .then(response => {
                if (response.status === 200 || response.data === 'True') {
                  Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Event updated!",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                }
              })
              .catch(error => {
                if (error.response?.data?.detail === 'Your session is expired!') {
                  this.$router.push('logout')
                } else {
                  Swal.fire("Oops!", "Calendar Events couldn't be updated, please contact your SysAdmin.", "error")
                }
              });
        },
        drop: function(e){

          let start = moment(e.date).add(1, 'days').format('MMMM D, YYYY h:mm A');
          let end = moment(start).add(1, 'hours').format('MMMM D, YYYY h:mm A');
          let event = JSON.parse(localStorage.getItem('creatingEvent'))

          const editTitle = event.title;
          const editcategory = event.category;

          this.edit = event;
          this.edit["title"] = editTitle;
          this.edit["classNames"] = editcategory;

          var date = new Date();
          var d = date.getDate();
          var m = date.getMonth();
          var y = date.getFullYear();
          new Date(y, m, d + 24, 16, 0)

          const data = {
            token: localStorage.getItem('jwt'),
            userEmail: localStorage.getItem('email'),
            event: {
              editID: event.localID || event.id,  // ✅ tu ID local
              googleEventID: event.googleEventID || event.id,  // ✅ id google (si aplica)
              providerID: event.providerID || 'google',
              editTitle: editTitle,
              editcategory: event.category,
              editDescription: event.description,
              editStart: start,
              editEnd: end,
              editLocation: event.location,
            },
            edit: this.edit,
            test: new Date(y, m, d + 24, 16, 0),
            userID: localStorage.getItem('id')
          }
          console.log(2)
          axios
              .post('/api/updateEvent', data)
              .then(response => {

                if (response === 'True') {
                  Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Event updated!",
                    showConfirmButton: false,
                    timer: 2000,
                  });
                }
              })
              .catch(error => {
                if (error.response) {

                  if (error.response.data.detail === 'Your session is expired!') {
                    this.$router.push('logout')
                  }

                  Swal.fire("Oops!", "Calendar Events couldn't be updated, please contact your SysAdmin.", "error")
                }
              })
          this.eventModal = false;

        },
        events: async (info, successCallback, failureCallback) => {
          try {
            const data = {
              token: localStorage.getItem('jwt'),
              userEmail: localStorage.getItem('email'),
              userID: localStorage.getItem('id'),
              from: info.startStr,
              to: info.endStr,
              calendarId: 'primary',
            };

            const url = this.mode === 'license-class' ? '/api/getLicenseClassEvents' : '/api/getCalendarEvents';
            const response = await axios.post(url, data);
            successCallback(response.data);
          } catch (error) {
            if (error.response && error.response.data?.detail === 'Your session is expired!') {
              this.$router.push('logout');
              return;
            }
            Swal.fire("Oops!", "Calendar Events couldn't be loaded, please contact your SysAdmin.", "error");
            failureCallback(error);
          }
        },
      },
    };
  },
  components: {
    FullCalendar,
    SimpleBar,
    CalendarIcon,
    flatPickr,
  },
  methods: {
    isTeacher() {
      const jwt = localStorage.getItem('jwt');
      if (!jwt) return false;
      try {
        const decoded = jwt_decode(jwt);
        const group = decoded.userGroupCode || decoded.userGroup || "";
        const views = decoded.vueViews || [];
        return group === 'SUPER_ADMIN_GROUP' || views.includes('EDIT_LICENSE_CLASS');
      } catch (e) {
        return false;
      }
    },

    formatDate(date) {
      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var d = new Date(date),
          month = "" + monthNames[d.getMonth()],
          day = "" + d.getDate(),
          year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [day + " " + month, year].join(",");
    },
    getInitialView() {
      if (window.innerWidth >= 768 && window.innerWidth < 1200) {
        return "timeGridWeek";
      } else if (window.innerWidth <= 768) {
        return "listMonth";
      } else {
        return "dayGridMonth";
      }
    },
    /**
     * Modal form submit
     */
    // eslint-disable-next-line no-unused-vars
    async handleSubmit(e) {
      this.submitted = true;

      // stop here if form is invalid
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      } else {
        const title = this.event.title;
        const category = this.event.category;
        let calendarApi = this.$refs.fullCalendar.getApi();
        this.currentEvents = calendarApi.addEvent({
          id: this.newEventData.length + 1,
          title,
          start: this.toDate,
          end: this.fromDate,
          classNames: [category],
        });

        this.successmsg();
        this.showModal = false;
        this.newEventData = {};
      }
      this.submitted = false;
      this.event = {};
    },
    // eslint-disable-next-line no-unused-vars
    hideModal(e) {
      this.submitted = false;
      this.showModal = false;
      this.event = {};
    },
    /**
     * Edit event modal submit
     */  // eslint-disable-next-line no-unused-vars
    async editSubmit(e) {
      const ext = (this.selectedEvent && this.selectedEvent.extendedProps) ? this.selectedEvent.extendedProps : {};

      const localID = this.editevent.localID || ext.localID || null;
      const googleEventID = this.editevent.googleEventID || ext.googleEventID || (this.selectedEvent ? this.selectedEvent.id : null);

      const data = {
        token: localStorage.getItem('jwt'),
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
        event: {
          editID: localID,
          googleEventID: googleEventID,
          providerID: this.editevent.providerID || 'google',

          editTitle: this.editevent.editTitle,
          editcategory: this.editevent.editcategory,
          editDescription: this.editevent.editDescription,
          editStart: this.editevent.editStart,
          editEnd: this.editevent.editEnd,
          editLocation: this.editevent.editLocation,
        }
      };

      const url = this.mode === 'license-class' ? '/api/saveLicenseClassEvent' : '/api/updateEvent';
      const payload = this.mode === 'license-class' ? {
        token: localStorage.getItem('jwt'),
        action: 'update',
        event: {
          id: localID,
          title: this.editevent.editTitle,
          start: this.editevent.editStart,
          end: this.editevent.editEnd,
          description: this.editevent.editDescription,
          location: this.editevent.editLocation,
          className: 'license-class'
        }
      } : data;

      await axios
          .post(url, payload)
          .then(() => {
            this.updateCalendarEvents()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Event updated!",
              showConfirmButton: false,
              timer: 1000,
            });
          })
          .catch(error => {
            if (error.response) {
              if(error.response.data.detail === 'Your session is expired!'){
                this.$router.push('logout')
              }
              Swal.fire("Oops!", "Calendar Events couldn't be updated, please contact your SysAdmin.", "error")
            }
          })
      this.successmsg();
      this.eventModal = false;
    },
    /**
     * Delete event
     */
    async deleteEvent() {
      const ext = (this.selectedEvent && this.selectedEvent.extendedProps) ? this.selectedEvent.extendedProps : {};
      const localID = this.editevent.localID || ext.localID || null;
      const googleEventID = this.editevent.googleEventID || ext.googleEventID || (this.selectedEvent ? this.selectedEvent.id : null);

      const url = this.mode === 'license-class' ? '/api/saveLicenseClassEvent' : '/api/deleteEvent';
      const payload = this.mode === 'license-class' ? {
        token: localStorage.getItem('jwt'),
        action: 'delete',
        event: {
          id: localID
        }
      } : {
        token: localStorage.getItem('jwt'),
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
        event: {
          editID: localID,
          googleEventID: googleEventID,
          providerID: (ext.providerID || this.editevent.providerID || 'google'),
        }
      };

      try {
        await axios.post(url, payload);

        // 1) quítalo del UI instantáneo si tienes el EventApi real
        if (this.editApi && typeof this.editApi.remove === 'function') {
          this.editApi.remove();
        }

        this.eventModal = false;

        // 2) y ahora fuerza refresh del calendario para que quede 100% consistente
        const calApi = this.$refs.fullCalendar?.getApi?.();
        if (calApi) {
          calApi.refetchEvents();
        } else {
          // fallback si no tienes ref
          await this.updateCalendarEvents();
        }

      } catch (error) {
        Swal.fire("Oops!", "Event couldn't be deleted.", "error");
      }
    },
    /**
     * Click any date to add event
     * Modal open for add event
     */
    dateClicked(info) {
      this.newEventData = info;
      this.showModal = true;
    },
    /**
     * Modal open for edit event
     */
    editEvent(info) {
      if (info.event.display === 'background') return;

      if (info.event.extendedProps?.isScheduleSlot) {
        const Swal = require("sweetalert2");
        const link = info.event.extendedProps.link;
        const password = info.event.extendedProps.password;
        const isClass = info.event.extendedProps.isClassSlot;
        
        let htmlContent = isClass ? "This block indicates the Teacher's scheduled license class." : "This block indicates the leader's available hours for interviews.";
        if (link) {
           htmlContent += `<br><br><b>Meeting Link:</b> <a href="${link}" target="_blank">${link}</a>`;
        }
        if (password) {
           htmlContent += `<br><b>Password:</b> ${password}`;
        }
        
        Swal.fire({
          title: isClass ? "License Class Schedule" : "Leader Availability",
          html: htmlContent,
          icon: "info",
          confirmButtonColor: isClass ? "#6559cc" : "#34c38f"
        });
        return;
      }

      // Check if it's an interview event (has email)
      if (info.event.extendedProps?.email) {
        const props = info.event.extendedProps || {};
        const moment = require('moment');
        this.selectedInterview = {
          id: info.event.id,
          title: info.event.title,
          start: moment(info.event.start).format('MMMM D, YYYY h:mm A'),
          location: props.location || 'N/A',
          email: props.email || 'N/A',
          phoneNumber: props.phoneNumber || 'N/A',
          interviewLink: props.interviewLink || '',
          departmentName: props.departmentName || ''
        };
        this.interviewModal = true;
        return;
      }

      this.selectedEvent = info.event;
      const ext = info.event.extendedProps || {};

      this.editevent.localID = ext.localID || null;
      this.editevent.googleEventID = ext.googleEventID || info.event.id || null;
      this.editevent.providerID = ext.providerID || 'google';

      this.editevent.editTitle = info.event.title || '';
      this.editevent.editDescription = ext.description || '';
      this.editevent.editLocation = ext.location || '';
      this.editevent.editcategory = (info.event.classNames && info.event.classNames[0]) ? info.event.classNames[0] : '';

      this.editevent.editStart = info.event.start ? info.event.start.toISOString() : '';
      this.editevent.editEnd = info.event.end ? info.event.end.toISOString() : this.editevent.editStart;

      this.eventModal = true;
    },
    closeModal() {
      this.eventModal = false;
      this.interviewModal = false;
    },
    refetchEvents() {
      const api = this.$refs.fullCalendar?.getApi?.();
      if (api) api.refetchEvents();
    },
    confirm() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.deleteEvent();
          Swal.fire("Deleted!", "Event has been deleted.", "success");
        }
      });
    },
    async updateCalendarEvents(){
      const api = this.$refs.fullCalendar.getApi();
      const from = api.view.activeStart.toISOString();
      const to = api.view.activeEnd.toISOString();

      axios.post('/api/getCalendarEvents', {
        token: localStorage.getItem('jwt'),
        from: from,
        to: to,
        calendarId: 'primary'
      })
    },
    /**
     * Show list of events
     */
    handleEvents(events) {
      this.currentEvents = events;
    },
    /**
     * Show successfull Save Dialog
     */
    successmsg() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Event has been saved!",
        showConfirmButton: false,
        timer: 1000,
      });
    },
    createEvent() {
      this.errors = [];

      if (!this.event.title) this.errors.push("Event title is required.");
      if (!this.event.description) this.errors.push("Event Description is required.");
      if (this.mode !== 'license-class') {
        if (!document.getElementById("createCategory").value) this.errors.push("Event Category is required.");
      }

      if (this.errors.length) return;

      if (this.mode === 'license-class') {
        this.event.category = 'license-class';
      } else {
        this.event.category = document.getElementById("createCategory").value;
      }

      const startISO = new Date(this.event.start).toISOString();
      const endISO = this.event.end ? new Date(this.event.end).toISOString() : null;

      const data = {
        token: localStorage.getItem("jwt"),
        userEmail: localStorage.getItem("email"),
        userID: localStorage.getItem("id"),
        event: {
          title: this.event.title,
          start: startISO,              // ✅ ISO
          end: endISO,                  // ✅ ISO o null
          description: this.event.description,
          location: this.event.location || "",
          className: this.event.category,
          createButton: 1
        }
      };
      const url = this.mode === "license-class" ? "/api/saveLicenseClassEvent" : "/api/createEvent";
      const payload = this.mode === "license-class" ? {
        token: localStorage.getItem("jwt"),
        action: "create",
        event: {
          title: this.event.title,
          start: startISO,
          end: endISO,
          description: this.event.description,
          location: this.event.location || "",
          className: "license-class"
        }
      } : data;

      axios.post(url, payload)
          .then(() => {
            Swal.fire({ position:"top-end", icon:"success", title:"Event created!", showConfirmButton:false, timer:1000 });
            location.reload();
          })
          .catch(err => {
            if (err.response?.data?.detail === "Your session is expired!") this.$router.push("logout");
            Swal.fire("Oops!", "Calendar Events couldn't be saved, please contact your SysAdmin.", "error");
          });
    },
    connectGoogleCalendar() {
      const userID = localStorage.getItem("id");
      const token = localStorage.getItem("jwt");

      // Abre OAuth start (tu endpoint)
      const url = `https://a3j63o3n9.dmbgroup.online/api/gcal/oauth/start?userID=${encodeURIComponent(userID)}&token=${encodeURIComponent(token)}`;
      const w = window.open(url, "gcal_oauth", "width=520,height=700");

      // Cuando se cierre la ventana, intentamos refrescar eventos
      const timer = setInterval(() => {
        if (!w || w.closed) {
          clearInterval(timer);
          // Aquí recargas eventos sin recargar toda la página
          // Si tú no tienes metodo de refetch, usa location.reload() por ahora
          this.fetchCalendarEvents?.() || location.reload();
        }
      }, 700);
    },
    syncGoogleCalendar() {
      // Re-llama getCalendarEvents del rango actual (o recarga)
      this.fetchCalendarEvents?.() || location.reload();
    }
  },
  async mounted() {
    if (this.mode === 'license-class') {
      const teacher = this.isTeacher();
      this.calendarOptions.editable = teacher;
      this.calendarOptions.selectable = teacher;
      this.calendarOptions.droppable = teacher;
    } else if (this.mode === 'combined') {
      // In combined mode: allow creating license class events only if teacher
      const teacher = this.isTeacher();
      this.calendarOptions.editable = teacher;
      this.calendarOptions.selectable = teacher;
      this.calendarOptions.droppable = false; // no drag-drop in combined
      
      // Default to the initialView
    }

    // 1) External draggable events (NO crear en backend aquí)
    const externalEventsEl = document.getElementById("external-events");
    if (externalEventsEl) {
      new Draggable(externalEventsEl, {
        itemSelector: ".external-event",
        eventData: function (eventEl) {
          return {
            title: eventEl.innerText,
            className: eventEl.getAttribute("data-class"),
          };
        },
      });
    }

    // 2) FullCalendar: cargar eventos por rango automáticamente
    //    (esto reemplaza tu axios en mounted)
    this.calendarOptions.events = async (info, successCallback, failureCallback) => {
      try {
        const token = localStorage.getItem('jwt');
        const moment = require('moment');

        const parseLicenseEvents = (data) => Array.isArray(data) ? data.map(ev => ({
          ...ev,
          color: '#6559cc',
          className: 'license-class'
        })) : [];

        const parseInterviewEvents = (data, isClass = false, hideInterviews = false) => {
          if (!data || typeof data !== 'object') return [];
          const { events, schedule } = data;
          const bgEvents = [];
          const daysMap = { sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 };
          for (const [dayName, slots] of Object.entries(schedule || {})) {
            const dayIdx = daysMap[dayName.toLowerCase()];
            if (dayIdx === undefined || !slots) continue;
            slots.forEach(slot => {
              const slotTime = typeof slot === 'string' ? slot : slot.time;
              const deptName = typeof slot === 'object' ? slot.dept : (isClass ? "License Class" : "Availability");
              const slotLink = typeof slot === 'object' ? slot.link : "";
              const slotPassword = typeof slot === 'object' ? slot.password : "";

              const startMoment = moment(slotTime, "HH:mm");
              const endMoment = moment(startMoment).add(30, 'minutes');
              bgEvents.push({
                daysOfWeek: [dayIdx],
                startTime: startMoment.format("HH:mm:ss"),
                endTime: endMoment.format("HH:mm:ss"),
                title: startMoment.format("h:mm A") + (isClass ? " - Class" : " - " + deptName),
                color: isClass ? '#6559cc' : '#0ab39c',
                textColor: '#ffffff',
                className: isClass ? 'license-class-slot' : 'leader-availability-slot',
                extendedProps: { 
                  isScheduleSlot: true,
                  isClassSlot: isClass,
                  link: slotLink,
                  password: slotPassword
                }
              });
            });
          }
          const formattedEvents = (events || []).map(ev => ({
            ...ev,
            color: isClass ? '#6559cc' : '#f7b84b',
            className: isClass ? 'license-class' : 'leader-interview-event'
          }));
          return [...(hideInterviews ? [] : formattedEvents), ...bgEvents];
        };

        if (this.mode === 'combined') {
          // Fetch both sources in parallel
          const requests = [
            axios.post('/api/getLicenseClassEvents', { token, start: info.startStr, end: info.endStr })
              .catch(() => ({ data: [] })),
            axios.get('/api/department-schedule', { params: { token, departmentID: 0 } })
              .catch(() => ({ data: { schedule: {} } }))
          ];
          if (this.isAdmin && this.departmentId) {
            requests.push(
              axios.post('/api/getLeaderInterviews', { token, departmentID: this.departmentId, start: info.startStr, end: info.endStr })
                .catch(() => ({ data: { events: [], schedule: {} } }))
            );
          }
          const results = await Promise.all(requests);
          const classRes = results[0];
          const classScheduleRes = results[1];
          const interviewRes = results[2];

          const classEvents = parseLicenseEvents(classRes.data);
          const classScheduleEvents = parseInterviewEvents(classScheduleRes.data, true, true);
          const interviewEvents = interviewRes ? parseInterviewEvents(interviewRes.data, false, true) : [];
          successCallback([...classEvents, ...classScheduleEvents, ...interviewEvents]);

        } else if (this.mode === 'license-class') {
          const requests = [
            axios.post('/api/getLicenseClassEvents', { token, start: info.startStr, end: info.endStr })
              .catch(() => ({ data: [] })),
            axios.get('/api/department-schedule', { params: { token, departmentID: 0 } })
              .catch(() => ({ data: { schedule: {} } }))
          ];
          const results = await Promise.all(requests);
          const classRes = results[0];
          const classScheduleRes = results[1];

          const classEvents = parseLicenseEvents(classRes.data);
          const classScheduleEvents = parseInterviewEvents(classScheduleRes.data, true, true);
          successCallback([...classEvents, ...classScheduleEvents]);

        } else if (this.mode === 'leader-interviews') {
          const response = await axios.post('/api/getLeaderInterviews', { token, departmentID: this.departmentId, start: info.startStr, end: info.endStr });
          successCallback(parseInterviewEvents(response.data));

        } else {
          const response = await axios.post('/api/getCalendarEvents', {
            token,
            userEmail: localStorage.getItem('email'),
            userID: localStorage.getItem('id'),
            from: info.startStr,
            to: info.endStr,
            calendarId: 'primary',
          });
          successCallback(response.data);
        }

      } catch (error) {
        if (error.response?.data?.detail === 'Your session is expired!') {
          this.$router.push('logout');
          return;
        }
        Swal.fire("Oops!", "Calendar Events couldn't be loaded, please contact your SysAdmin.", "error");
        failureCallback(error);
      }
    };

    // 3) Crear evento en backend cuando el usuario lo suelta en el calendario
    //    (aquí ya tienes fecha real, y puedes setear el ID devuelto)
    this.calendarOptions.eventReceive = async (info) => {
      try {
        const data = {
          token: localStorage.getItem('jwt'),
          userEmail: localStorage.getItem('email'),
          userID: localStorage.getItem('id'),
          event: {
            title: info.event.title,
            description: info.event.extendedProps?.description || '',
            // manda ISO para que tu backend lo pueda convertir fácil
            start: info.event.start ? info.event.start.toISOString() : null,
            end: info.event.end ? info.event.end.toISOString() : null,
            className: (info.event.classNames && info.event.classNames[0]) ? info.event.classNames[0] : '',
            createButton: 1
          }
        };

        const response = await axios.post('/api/createEvent', data);
        if (response.status === 200) {
          const newId = response.data['ID'];
          // asigna el ID del backend al evento en el calendario
          info.event.setProp('id', newId);

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Event created!",
            showConfirmButton: false,
            timer: 1000,
          });
        }
      } catch (error) {
        // si falló, revertimos el drop (borra el evento visual)
        info.revert();

        if (error.response?.data?.detail === 'Your session is expired!') {
          this.$router.push('logout');
          return;
        }
        Swal.fire("Oops!", "Calendar Events couldn't be saved, please contact your SysAdmin.", "error");
      }
    };

    if (window.opener) window.opener.postMessage({ type: "gcal_connected" }, "*");
    window.close();

    window.addEventListener("message", (e) => {
      if (e.data?.type === "gcal_connected") {
        this.fetchCalendarEvents?.() || location.reload();
      }
    });
  }

};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-xl-3">
          <div class="card card-h-100" v-if="mode !== 'leader-interviews' && mode !== 'combined' && mode !== 'license-class'">
            <div class="card-body">
              <button class="btn btn-primary" @click="connectGoogleCalendar">
                Connect Google Calendar
              </button>

              <button class="btn btn-outline-primary ms-2" @click="syncGoogleCalendar">
                Sync now
              </button>
              <br>
              <button class="btn btn-primary w-100" id="btn-new-event" @click="showModal = true" style="margin-top: 10px">
                <i class="mdi mdi-plus"></i> Create New Event
              </button>
            </div>
          </div>
          <div>
            <h5 class="mb-1">{{ $t("t-upcoming-events") }}</h5>
            <p class="text-muted">Don't miss scheduled events</p>
            <SimpleBar
                class="upcoming-events pe-2 me-n1 mb-3"
                data-simplebar="init"
                style="height: 400px"
            >
              <div
                  class="card mb-3"
                  v-for="event in currentEvents"
                  :key="event.id"
              >
                <div class="card-body">
                  <div class="d-flex mb-3">
                    <div class="flex-grow-1">
                      <i
                          :class="`mdi mdi-checkbox-blank-circle me-2 ${event.classNames[0]} `"
                      ></i
                      ><span class="fw-medium">{{
                        this.formatDate(event.start)
                      }}</span>
                    </div>
                    <div class="flex-shrink-0">
                      <small class="badge badge-soft-primary ms-auto"></small>
                    </div>
                  </div>
                  <h6 class="card-title fs-16">{{ event.title }}</h6>
                  <p class="text-muted text-truncate-two-lines mb-0">
                    {{ event.description }}
                  </p>
                </div>
              </div>
            </SimpleBar>
          </div>
          <div class="card">
            <div class="card-body bg-soft-info">
              <div class="d-flex">
                <div class="flex-shrink-0">
                  <CalendarIcon
                      class="text-info icon-dual-info"
                  ></CalendarIcon>
                </div>
                <div class="flex-grow-1 ms-3">
                  <h6 class="fs-15">Welcome to your Calendar!</h6>
                  <p class="text-muted mb-0">
                    Event that applications book will appear here. Click on an
                    event to see the details and manage applicants event.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!--end card-->
        </div>
        <div class="col-xl-9">
          <div class="card card-h-100">
            <div class="card-body">
              <FullCalendar ref="fullCalendar" :options="calendarOptions" />
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
  <b-modal
      v-model="showModal"
      title="Add New Event"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer>
    <form @submit.prevent="handleSubmit">
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Title</label>
            <input
                id="name"
                v-model="event.title"
                type="text"
                class="form-control"
                placeholder="Insert Event name"
                :class="{ 'is-invalid': submitted && v$.event.title.$error }"
            />
            <div
                v-if="submitted && v$.event.title.$error"
                class="invalid-feedback">
              <span v-if="v$.event.title.required.$message">{{
                  v$.event.title.required.$message
                }}</span>
            </div>
          </div>
        </div>
        <div class="col-6">
          <label for="filterFromDate" class="form-label"> Start On </label>
          <flat-pickr
              v-model="event.start"
              :config="dateTimeConfig"
              class="form-control"
          ></flat-pickr>
        </div>
        <div class="col-6">
          <label for="filterToDate" class="form-label"> End On</label>
          <flat-pickr
              v-model="event.end"
              :config="dateTimeConfig"
              class="form-control"
          ></flat-pickr>
        </div>
        <div class="col-12" style="margin-top: 5px;">
            <label for="eventDescription" class="form-label">Description</label>
            <textarea class="form-control" id="eventDescription" rows="3" v-model="event.description"></textarea>
        </div>
        <div class="col-12" style="margin-top: 5px;" v-if="mode !== 'license-class'">
          <div class="mb-3">
            <label class="control-label">Category</label>
            <select
                v-model="event.category"
                class="form-control"
                name="category"
                id="createCategory"
            >
              <option
                  v-for="option in categories"
                  :key="option.backgroundColor"
                  :value="`${option.value}`"
              >
                {{ option.name }}
              </option>
            </select>
            <div
                v-if="submitted && v$.event.category.$error"
                class="invalid-feedback"
            >
              <span v-if="v$.event.category.required.$message">{{
                  v$.event.category.required.$message
                }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end pt-5 mt-3">
        <b-button variant="light" @click="hideModal">Close</b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="createEvent">Create event</b-button>
      </div>
    </form>
  </b-modal>

  <!-- Edit Modal -->
  <b-modal
      v-model="eventModal"
      title="Edit Event"
      title-class="text-black font-18"
      hide-footer
      body-class="p-3"
  >
    <form @submit.prevent="editSubmit">
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Event Name</label>
            <input
                id="name1"
                v-model="editevent.editTitle"
                type="text"
                class="form-control"
                placeholder="Insert Event name"
            />
          </div>
        </div>
        <div class="col-6">
          <label for="filterFromDate" class="form-label"> Start On </label>
          <flat-pickr
              v-model="editevent.editStart"
              :config="dateTimeConfig"
              class="form-control"
              data-provider="timepickr"
              data-time-hrs="true"
          ></flat-pickr>
        </div>
        <div class="col-6">
          <label for="filterToDate" class="form-label"> End On</label>
          <flat-pickr
              v-model="editevent.editEnd"
              :config="dateTimeConfig"
              class="form-control"
              data-provider="timepickr"
              data-time-hrs="true"
          ></flat-pickr>
        </div>
        <div class="col-12" style="margin-top: 5px;">
          <label for="eventDescription" class="form-label">Location</label>
          <input class="form-control" id="eventDescription" v-model="editevent.editLocation">
        </div>
        <div class="col-12" style="margin-top: 5px;">
          <label for="eventDescription" class="form-label">Description</label>
          <textarea class="form-control" id="eventDescription" rows="5" v-model="editevent.editDescription"></textarea>
        </div>
      </div>
      <div class="text-end p-3">
        <b-button variant="light" @click="closeModal">Close</b-button>
        <b-button class="ms-1" variant="danger" @click="confirm"
        >Delete</b-button
        >
        <b-button class="ms-1" variant="success" @click="editSubmit"
        >Save</b-button
        >
      </div>
    </form>
  </b-modal>

  <!-- Interview Detail Modal -->
  <b-modal
      v-model="interviewModal"
      title="Interview Details"
      title-class="text-black font-18"
      hide-footer
      body-class="p-3"
  >
    <div class="row g-3" v-if="selectedInterview">
      <div class="col-12">
        <h5 class="fw-semibold mb-1">{{ selectedInterview.title }}</h5>
        <span class="badge bg-soft-primary text-primary">{{ selectedInterview.departmentName }}</span>
      </div>
      <div class="col-12">
        <label class="text-muted small">Date &amp; Time</label>
        <p class="mb-0"><i class="ri-calendar-line me-1 text-primary"></i> {{ selectedInterview.start }}</p>
      </div>
      <div class="col-12" v-if="selectedInterview.location !== 'N/A'">
        <label class="text-muted small">Location</label>
        <p class="mb-0"><i class="ri-map-pin-line me-1 text-primary"></i> {{ selectedInterview.location }}</p>
      </div>
      <div class="col-md-6">
        <label class="text-muted small">Email</label>
        <p class="mb-0"><i class="ri-mail-line me-1 text-primary"></i> {{ selectedInterview.email }}</p>
      </div>
      <div class="col-md-6">
        <label class="text-muted small">Phone</label>
        <p class="mb-0"><i class="ri-phone-line me-1 text-primary"></i> {{ selectedInterview.phoneNumber }}</p>
      </div>
      <div class="col-12" v-if="selectedInterview.interviewLink">
        <label class="text-muted small">Interview Link</label>
        <p class="mb-0">
          <a :href="selectedInterview.interviewLink" target="_blank" class="btn btn-sm btn-soft-primary">
            <i class="ri-video-line me-1"></i> Join Interview
          </a>
        </p>
      </div>
    </div>
    <div class="text-end pt-4">
      <b-button variant="light" @click="interviewModal = false">Close</b-button>
    </div>
  </b-modal>

</template>
